import _ from '@luna/lodash';
import type { COUNTRY } from '@shared/core-types';

import type { ReservationFeatures } from '../types/ReservationFeatures';
import { reservations as base } from './base';
import { reservations as AT } from './countries/AT';
import { reservations as CZ } from './countries/CZ';
import { reservations as HR } from './countries/HR';
import { reservations as HU } from './countries/HU';
import { reservations as RO } from './countries/RO';
import { reservations as SK } from './countries/SK';

export const reservationsFeatures: Record<COUNTRY, ReservationFeatures> = {
    AT: _.merge({}, base, AT),
    CZ: _.merge({}, base, CZ),
    HR: _.merge({}, base, HR),
    HU: _.merge({}, base, HU),
    RO: _.merge({}, base, RO),
    SK: _.merge({}, base, SK),
    RS: _.merge({}, base, {}),
};
